(function ($) {
  'use strict';

  var MAX_SAMPLES_TOTAL = window.MAX_SAMPLES_TOTAL;
  var MAX_PER_SKU = 1;

  function showMessage(message) {
var $origin = $('form[action$="/cart/add"] input[type="submit"]:visible').first();

  if (!$origin.length) {
    $origin = $('#cartform .quantity-container input:visible').first();
  }

  if (!$origin.length) {
    $origin = $('#cartform [name="checkout"]:visible').first();
  }

  if (!$origin.length) {
    $origin = $('body');
  }

  if (window.theme && typeof theme.showQuickPopup === 'function') {
    theme.showQuickPopup(message, $origin);
    $('.simple-popup').css('z-index', '999999');
  } else {
    alert(message);
  }
}

  function getCart() {
    return $.getJSON('/cart.js');
  }

function isSample(item) {
  return item && Number(item.product_id) === 9037772521800;
}

  function getLimitMessage(cart, sku, variantId, proposedQuantity, excludedLine) {
    var totalSamples = 0;
    var matchingSamples = 0;

    $.each(cart.items || [], function (index, item) {
      if (!isSample(item) || index + 1 === excludedLine) {
        return;
      }

      totalSamples += Number(item.quantity) || 0;

      var sameSample = sku
        ? item.sku === sku
        : String(item.variant_id) === String(variantId);

      if (sameSample) {
        matchingSamples += Number(item.quantity) || 0;
      }
    });

 if (matchingSamples + proposedQuantity > MAX_PER_SKU) {
  return window.sampleLimitsTranslations.perSku;
}

if (totalSamples + proposedQuantity > MAX_SAMPLES_TOTAL) {
  return window.sampleLimitsTranslations.total.replace(
    '{{ count }}',
    MAX_SAMPLES_TOTAL
  );
}

    return '';
  }

  /*
   * Product page: check the cart before the theme's AJAX
   * add-to-cart handler runs.
   */
$(document).on('submit.sampleLimits', 'form[action$="/cart/add"]', function (event) {
    var form = this;
    var $form = $(form);

    if ($form.data('sampleLimitsApproved')) {
      $form.removeData('sampleLimitsApproved');
      return;
    }

    if ($form.data('sampleLimitsChecking')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }

    var productData;

    try {
      if (window.theme &&
          theme.OptionManager &&
          typeof theme.OptionManager.getProductData === 'function') {
        productData = theme.OptionManager.getProductData($form);
      }
    } catch (error) {
      productData = null;
    }

  if (!productData || Number(productData.id) !== 9037772521800) {
  return;
}

    event.preventDefault();
    event.stopImmediatePropagation();

    var variantId = $form.find('[name="id"]').val();
    var variant = $.grep(productData.variants || [], function (candidate) {
      return String(candidate.id) === String(variantId);
    })[0];

    var quantity = Number($form.find('[name="quantity"]').val() || 1);

    if (!variant || !Number.isInteger(quantity) || quantity < 1) {
      showMessage('Please select a valid sample and quantity.');
      return false;
    }

    $form.data('sampleLimitsChecking', true);

    getCart()
      .done(function (cart) {
        var message = getLimitMessage(
          cart,
          variant.sku || '',
          variant.id,
          quantity,
          0
        );

        if (message) {
          showMessage(message);
          return;
        }

        $form.data('sampleLimitsApproved', true);

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          $form.trigger('submit');
        }
      })
      .fail(function () {
        showMessage('Could not check your cart. Please try again.');
      })
      .always(function () {
        $form.removeData('sampleLimitsChecking');
      });

    return false;
  });

  /*
   * Cart page: intercept quantity changes for sample products.
   * The existing theme handler runs only after this check succeeds.
   */
  $(document).on(
    'keyup.sampleLimits change.sampleLimits',
    '.quantity-container input',
    function (event) {
      var input = this;
      var $input = $(input);
      var $row = $input.closest('[data-line], .cart-item, tr');
      var line = Number($input.data('line'));
      var proposedQuantity = Number($input.val());
      var previousQuantity = Number($input.data('previousValue'));

      if (!line || !Number.isInteger(proposedQuantity) ||
          proposedQuantity < 1 || proposedQuantity === previousQuantity) {
        return;
      }

      if ($input.data('sampleLimitsApproved')) {
        $input.removeData('sampleLimitsApproved');
        return;
      }

      if ($input.data('sampleLimitsChecking')) {
        event.stopImmediatePropagation();
        return;
      }

      /*
       * Check every cart quantity change against the current cart.
       * For non-sample lines, the theme handler continues unchanged.
       */
      event.stopImmediatePropagation();
      $input.data('sampleLimitsChecking', true);

      getCart()
        .done(function (cart) {
          var item = cart.items && cart.items[line - 1];

          if (!item) {
            $input.val(previousQuantity);
            showMessage('Could not verify this cart item. Please refresh the page.');
            return;
          }

          if (isSample(item)) {
            var message = getLimitMessage(
              cart,
              item.sku || '',
              item.variant_id,
              proposedQuantity,
              line
            );

            if (message) {
              $input.val(item.quantity);
              $input.data('previousValue', item.quantity);
              showMessage(message);
              return;
            }
          }

          $input.data('sampleLimitsApproved', true);
          $input.trigger('change.cartTemplateSection');
        })
        .fail(function () {
          $input.val(previousQuantity);
          showMessage('Could not check your cart. Please try again.');
        })
        .always(function () {
          $input.removeData('sampleLimitsChecking');
        });
    }
  );

})(jQuery);